export const approvedISOStandards: approvedISOType = {
    "Currency": [
        {
            "Currency": "Argentine Peso",
            "Code": "ARS"
        },
        {
            "Currency": "Australian Dollar",
            "Code": "AUD"
        },
        {
            "Currency": "Azerbaijanian Manat",
            "Code": "AZN"
        },
        {
            "Currency": "Bahraini Dinar",
            "Code": "BHD"
        },
        {
            "Currency": "Belarusian Ruble",
            "Code": "BYR"
        },
        {
            "Currency": "Bolivian Boliviano",
            "Code": "BOB"
        },
        {
            "Currency": "Bosnia and Herzegovina Covertible Mark",
            "Code": "BAM"
        },
        {
            "Currency": "Brazilian Real",
            "Code": "BRL"
        },
        {
            "Currency": "Bulgarian Lev",
            "Code": "BGN"
        },
        {
            "Currency": "Canadian Dollar",
            "Code": "CAD"
        },
        {
            "Currency": "Chilean Peso",
            "Code": "CLP"
        },
        {
            "Currency": "China Yuan Renminbi",
            "Code": "CNY"
        },
        {
            "Currency": "Columbian Peso",
            "Code": "COP"
        },
        {
            "Currency": "Costa Rican Colon",
            "Code": "CRC"
        },
        {
            "Currency": "Croatian Kuna",
            "Code": "HRK"
        },
        {
            "Currency": "Czech Koruna",
            "Code": "CZK"
        },
        {
            "Currency": "Danish Krone",
            "Code": "DKK"
        },
        {
            "Currency": "Dominican Peso",
            "Code": "DOP"
        },
        {
            "Currency": "East Caribbean Dollar",
            "Code": "XCD"
        },
        {
            "Currency": "Egyptian Pound",
            "Code": "EGP"
        },
        {
            "Currency": "Ethiopian Birr",
            "Code": "ETB"
        },
        {
            "Currency": "Euro",
            "Code": "EUR"
        },
        {
            "Currency": "Fiji Dollar",
            "Code": "FJD"
        },
        {
            "Currency": "Georgian Lari",
            "Code": "GEL"
        },
        {
            "Currency": "Guatemala Quetzal",
            "Code": "GTQ"
        },
        {
            "Currency": "Haiti Goude",
            "Code": "HTG"
        },
        {
            "Currency": "Honduran Lempira",
            "Code": "HNL"
        },
        {
            "Currency": "Hong Kong Dolar",
            "Code": "HKD"
        },
        {
            "Currency": "Hungarian Forint",
            "Code": "HUF"
        },
        {
            "Currency": "Iceland Koruna",
            "Code": "ISK"
        },
        {
            "Currency": "Indian Rupee",
            "Code": "INR"
        },
        {
            "Currency": "Indonesia Rupiah",
            "Code": "IDR"
        },
        {
            "Currency": "Iranian Rial",
            "Code": "IRR"
        },
        {
            "Currency": "Jamaican Dollar",
            "Code": "JMD"
        },
        {
            "Currency": "Japanese Yen",
            "Code": "JPY"
        },
        {
            "Currency": "Jordanian Dinar",
            "Code": "JOD"
        },
        {
            "Currency": "Kazakhstan Tenge",
            "Code": "KZT"
        },
        {
            "Currency": "Kenyan Shilling",
            "Code": "KES"
        },
        {
            "Currency": "Korean Won",
            "Code": "KRW"
        },
        {
            "Currency": "Kuwaiti Dinar",
            "Code": "KWD"
        },
        {
            "Currency": "Latvian Lats",
            "Code": "LVL"
        },
        {
            "Currency": "Lebanese Pound",
            "Code": "LBP"
        },
        {
            "Currency": "Libyan Dinars",
            "Code": "LYD"
        },
        {
            "Currency": "Lithuanian Litas",
            "Code": "LTL"
        },
        {
            "Currency": "Malawi Kwacha",
            "Code": "MWK"
        },
        {
            "Currency": "Malaysian Ringgit",
            "Code": "MYR"
        },
        {
            "Currency": "Mauritius Rupee",
            "Code": "MUR"
        },
        {
            "Currency": "Mexican Peso",
            "Code": "MXN"
        },
        {
            "Currency": "Moldovan Leu",
            "Code": "MDL"
        },
        {
            "Currency": "Moroccan Dirham",
            "Code": "MAD"
        },
        {
            "Currency": "New Israeli Shekel",
            "Code": "ILS"
        },
        {
            "Currency": "New Zealand Dollar",
            "Code": "NZD"
        },
        {
            "Currency": "Nigerian Naira",
            "Code": "NGN"
        },
        {
            "Currency": "Norwegian Krone",
            "Code": "NOK"
        },
        {
            "Currency": "Omani Rial",
            "Code": "OMR"
        },
        {
            "Currency": "Pakistan Rupee",
            "Code": "PKR"
        },
        {
            "Currency": "Panamanian Balboa",
            "Code": "PAB"
        },
        {
            "Currency": "Paraguayan Guarani",
            "Code": "PYG"
        },
        {
            "Currency": "Peruvian Sol",
            "Code": "PEN"
        },
        {
            "Currency": "Philippine Peso",
            "Code": "PHP"
        },
        {
            "Currency": "Polish Zloty",
            "Code": "PLN"
        },
        {
            "Currency": "Pound Sterling",
            "Code": "GBP"
        },
        {
            "Currency": "Qatari Rial",
            "Code": "QAR"
        },
        {
            "Currency": "Romanian New Leu",
            "Code": "RON"
        },
        {
            "Currency": "Russian Ruble",
            "Code": "RUB"
        },
        {
            "Currency": "Saudi Arabian Riyal",
            "Code": "SAR"
        },
        {
            "Currency": "Serbian Dinar",
            "Code": "RSD"
        },
        {
            "Currency": "Singapore Dollar",
            "Code": "SGD"
        },
        {
            "Currency": "South African Rand",
            "Code": "ZAR"
        },
        {
            "Currency": "Sri Lanka Rupee",
            "Code": "LKR"
        },
        {
            "Currency": "Swedish Krona",
            "Code": "SEK"
        },
        {
            "Currency": "Swiss Franc",
            "Code": "CHF"
        },
        {
            "Currency": "Syrian Pound",
            "Code": "SYP"
        },
        {
            "Currency": "Taiwan New Dollar",
            "Code": "TWD"
        },
        {
            "Currency": "Thai Baht",
            "Code": "THB"
        },
        {
            "Currency": "Trinidad and Tobago Dollar",
            "Code": "TTD"
        },
        {
            "Currency": "Tunisian Dinar",
            "Code": "TND"
        },
        {
            "Currency": "Turkish Lira",
            "Code": "TRY"
        },
        {
            "Currency": "Ukranian Hryunia",
            "Code": "UAH"
        },
        {
            "Currency": "UAE Dirham",
            "Code": "AED"
        },
        {
            "Currency": "Uruguay Peso",
            "Code": "UYU"
        },
        {
            "Currency": "US Dollar",
            "Code": "USD"
        },
        {
            "Currency": "Venezuelan Bolivar",
            "Code": "VEF"
        },
        {
            "Currency": "Vietnam Dong",
            "Code": "VND"
        }
    ],
    "Provinces": [
        {
            "Province": "Alberta",
            "Code": "AB"
        },
        {
            "Province": "British Columbia",
            "Code": "BC"
        },
        {
            "Province": "Manitoba",
            "Code": "MB"
        },
        {
            "Province": "New Brunswick",
            "Code": "NB"
        },
        {
            "Province": "Newfoundland",
            "Code": "NL"
        },
        {
            "Province": "Nova Scotia",
            "Code": "NS"
        },
        {
            "Province": "Northwest Territories",
            "Code": "NT"
        },
        {
            "Province": "Nunavut",
            "Code": "NU"
        },
        {
            "Province": "Ontario",
            "Code": "ON"
        },
        {
            "Province": "Prince Edward Island",
            "Code": "PE"
        },
        {
            "Province": "Quebec",
            "Code": "QC"
        },
        {
            "Province": "Saskatchewan",
            "Code": "SK"
        },
        {
            "Province": "Yukon",
            "Code": "YT"
        }
    ],
    "States": [
        {
            "State": "Alabama",
            "Code": "AL"
        },
        {
            "State": "Alaska",
            "Code": "AK"
        },
        {
            "State": "American Samoa",
            "Code": "AS"
        },
        {
            "State": "Arizona",
            "Code": "AZ"
        },
        {
            "State": "Arkansas",
            "Code": "AR"
        },
        {
            "State": "Armed Forces Americas",
            "Code": "AA"
        },
        {
            "State": "Armed Forces Europe",
            "Code": "AE"
        },
        {
            "State": "Armed Forces Pacific",
            "Code": "AP"
        },
        {
            "State": "California",
            "Code": "CA"
        },
        {
            "State": "Colorado",
            "Code": "CO"
        },
        {
            "State": "Connecticut",
            "Code": "CT"
        },
        {
            "State": "Delaware",
            "Code": "DE"
        },
        {
            "State": "District of Columbia",
            "Code": "DC"
        },
        {
            "State": "Florida",
            "Code": "FL"
        },
        {
            "State": "Georgia",
            "Code": "GA"
        },
        {
            "State": "Guam",
            "Code": "GU"
        },
        {
            "State": "Hawaii",
            "Code": "HI"
        },
        {
            "State": "Idaho",
            "Code": "ID"
        },
        {
            "State": "Illinois",
            "Code": "IL"
        },
        {
            "State": "Indiana",
            "Code": "IN"
        },
        {
            "State": "International",
            "Code": "IT"
        },
        {
            "State": "Iowa",
            "Code": "IA"
        },
        {
            "State": "Kansas",
            "Code": "KS"
        },
        {
            "State": "Kentucky",
            "Code": "KY"
        },
        {
            "State": "Louisiana",
            "Code": "LA"
        },
        {
            "State": "Maine",
            "Code": "ME"
        },
        {
            "State": "Maryland",
            "Code": "MD"
        },
        {
            "State": "Massachusetts",
            "Code": "MA"
        },
        {
            "State": "Michigan",
            "Code": "MI"
        },
        {
            "State": "Minnesota",
            "Code": "MN"
        },
        {
            "State": "Mississippi",
            "Code": "MS"
        },
        {
            "State": "Missouri",
            "Code": "MO"
        },
        {
            "State": "Montana",
            "Code": "MT"
        },
        {
            "State": "Nebraska",
            "Code": "NE"
        },
        {
            "State": "Nevada",
            "Code": "NV"
        },
        {
            "State": "New Hampshire",
            "Code": "NH"
        },
        {
            "State": "New Jersey",
            "Code": "NJ"
        },
        {
            "State": "New Mexico",
            "Code": "NM"
        },
        {
            "State": "New York",
            "Code": "NY"
        },
        {
            "State": "North Carolina",
            "Code": "NC"
        },
        {
            "State": "North Dakota",
            "Code": "ND"
        },
        {
            "State": "Northern Mariana Is.",
            "Code": "MP"
        },
        {
            "State": "Ohio",
            "Code": "OH"
        },
        {
            "State": "Oklahoma",
            "Code": "OK"
        },
        {
            "State": "Oregon",
            "Code": "OR"
        },
        {
            "State": "Palau",
            "Code": "PW"
        },
        {
            "State": "Pennsylvania",
            "Code": "PA"
        },
        {
            "State": "Puerto Rico",
            "Code": "PR"
        },
        {
            "State": "Rhode Island",
            "Code": "RI"
        },
        {
            "State": "South Carolina",
            "Code": "SC"
        },
        {
            "State": "South Dakota",
            "Code": "SD"
        },
        {
            "State": "Tennessee",
            "Code": "TN"
        },
        {
            "State": "Texas",
            "Code": "TX"
        },
        {
            "State": "U.S.Virgin Islands",
            "Code": "VI"
        },
        {
            "State": "United States Federal",
            "Code": "US"
        },
        {
            "State": "Utah",
            "Code": "UT"
        },
        {
            "State": "Vermount",
            "Code": "VT"
        },
        {
            "State": "Virginia",
            "Code": "VA"
        },
        {
            "State": "Washington",
            "Code": "WA"
        },
        {
            "State": "West Virginia",
            "Code": "WV"
        },
        {
            "State": "Wisconsin",
            "Code": "WI"
        },
        {
            "State": "Wyoming",
            "Code": "WY"
        }
    ],
    "Countries": [
        {
            "Country": "Afghanistan",
            "Code": "AF"
        },
        {
            "Country": "Åland Islands",
            "Code": "AX"
        },
        {
            "Country": "Albania",
            "Code": "AL"
        },
        {
            "Country": "Algeria",
            "Code": "DZ"
        },
        {
            "Country": "American Samoa",
            "Code": "AS"
        },
        {
            "Country": "Andorra",
            "Code": "AD"
        },
        {
            "Country": "Angola",
            "Code": "AO"
        },
        {
            "Country": "Anguilla",
            "Code": "AI"
        },
        {
            "Country": "Antartica",
            "Code": "AQ"
        },
        {
            "Country": "Antigua and Barbuda",
            "Code": "AG"
        },
        {
            "Country": "Argentina",
            "Code": "AR"
        },
        {
            "Country": "Armenia",
            "Code": "AM"
        },
        {
            "Country": "Aruba",
            "Code": "AW"
        },
        {
            "Country": "Australia",
            "Code": "AU"
        },
        {
            "Country": "Austria",
            "Code": "AT"
        },
        {
            "Country": "Azerbaijan",
            "Code": "AZ"
        },
        {
            "Country": "Bahamas",
            "Code": "BS"
        },
        {
            "Country": "Bahrain",
            "Code": "BH"
        },
        {
            "Country": "Bangladesh",
            "Code": "BD"
        },
        {
            "Country": "Barbados",
            "Code": "BB"
        },
        {
            "Country": "Belarus",
            "Code": "BY"
        },
        {
            "Country": "Belgium",
            "Code": "BE"
        },
        {
            "Country": "Belize",
            "Code": "BZ"
        },
        {
            "Country": "Benin",
            "Code": "BJ"
        },
        {
            "Country": "Bermuda",
            "Code": "BM"
        },
        {
            "Country": "Bhutan",
            "Code": "BT"
        },
        {
            "Country": "Bolivia",
            "Code": "BO"
        },
        {
            "Country": "Bonaire, Sint Eustaius and Saba",
            "Code": "BQ"
        },
        {
            "Country": "Bosnia and Herzegovina",
            "Code": "BA"
        },
        {
            "Country": "Botswana",
            "Code": "BW"
        },
        {
            "Country": "Bouvet Island",
            "Code": "BV"
        },
        {
            "Country": "Brazil",
            "Code": "BR"
        },
        {
            "Country": "British Indian Ocean Territory",
            "Code": "IO"
        },
        {
            "Country": "Brunei Darussalam",
            "Code": "BN"
        },
        {
            "Country": "Bulgaria",
            "Code": "BG"
        },
        {
            "Country": "Burkina Faso",
            "Code": "BF"
        },
        {
            "Country": "Burundi",
            "Code": "BI"
        },
        {
            "Country": "Cambodia",
            "Code": "KH"
        },
        {
            "Country": "Cameroon",
            "Code": "CM"
        },
        {
            "Country": "Canada",
            "Code": "CA"
        },
        {
            "Country": "Cape Verde",
            "Code": "CV"
        },
        {
            "Country": "Cayman Islands",
            "Code": "KY"
        },
        {
            "Country": "Central African Republic",
            "Code": "CF"
        },
        {
            "Country": "Chad",
            "Code": "TD"
        },
        {
            "Country": "chile",
            "Code": "CL"
        },
        {
            "Country": "China",
            "Code": "CN"
        },
        {
            "Country": "Christmas Island",
            "Code": "CX"
        },
        {
            "Country": "Cocos (Keeling) Islands",
            "Code": "CC"
        },
        {
            "Country": "Colombia",
            "Code": "CO"
        },
        {
            "Country": "Comoros",
            "Code": "KM"
        },
        {
            "Country": "Congo",
            "Code": "CG"
        },
        {
            "Country": "Congo, Democratic Republic of",
            "Code": "CD"
        },
        {
            "Country": "Cook Islands",
            "Code": "CK"
        },
        {
            "Country": "Costa Rica",
            "Code": "CR"
        },
        {
            "Country": "Côte D’Ivoire",
            "Code": "CI"
        },
        {
            "Country": "Croatia",
            "Code": "HR"
        },
        {
            "Country": "Cuba",
            "Code": "CU"
        },
        {
            "Country": "Curacao",
            "Code": "CW"
        },
        {
            "Country": "Cyprus",
            "Code": "CY"
        },
        {
            "Country": "Czech Republic",
            "Code": "CZ"
        },
        {
            "Country": "Denmark",
            "Code": "DK"
        },
        {
            "Country": "Djibouti",
            "Code": "DJ"
        },
        {
            "Country": "Dominica",
            "Code": "DM"
        },
        {
            "Country": "Dominican Republic",
            "Code": "DO"
        },
        {
            "Country": "Ecuador",
            "Code": "EC"
        },
        {
            "Country": "Egypt",
            "Code": "EG"
        },
        {
            "Country": "El Salvador",
            "Code": "SV"
        },
        {
            "Country": "Equatorial Guinea",
            "Code": "GQ"
        },
        {
            "Country": "Eritrea",
            "Code": "ER"
        },
        {
            "Country": "Estonia",
            "Code": "EE"
        },
        {
            "Country": "Ethiopia",
            "Code": "ET"
        },
        {
            "Country": "Falkland Islands",
            "Code": "FK"
        },
        {
            "Country": "Faroe Islands",
            "Code": "FO"
        },
        {
            "Country": "Fiji",
            "Code": "FJ"
        },
        {
            "Country": "Finland",
            "Code": "FI"
        },
        {
            "Country": "France",
            "Code": "FR"
        },
        {
            "Country": "French Guiana",
            "Code": "GF"
        },
        {
            "Country": "French Polynesia",
            "Code": "PF"
        },
        {
            "Country": "French Southern Territories",
            "Code": "TF"
        },
        {
            "Country": "Gabon",
            "Code": "GA"
        },
        {
            "Country": "Gambia",
            "Code": "GM"
        },
        {
            "Country": "Georgia",
            "Code": "GE"
        },
        {
            "Country": "Germany",
            "Code": "DE"
        },
        {
            "Country": "Ghana",
            "Code": "GH"
        },
        {
            "Country": "Gibraltar",
            "Code": "GI"
        },
        {
            "Country": "Greece",
            "Code": "GR"
        },
        {
            "Country": "Greenland",
            "Code": "GL"
        },
        {
            "Country": "Grenada",
            "Code": "GD"
        },
        {
            "Country": "Guadeloupe",
            "Code": "GP"
        },
        {
            "Country": "Guam",
            "Code": "GU"
        },
        {
            "Country": "Guatemala",
            "Code": "GT"
        },
        {
            "Country": "Guernsey",
            "Code": "GG"
        },
        {
            "Country": "Guinea",
            "Code": "GN"
        },
        {
            "Country": "Guinea-Bissau",
            "Code": "GW"
        },
        {
            "Country": "Guyana",
            "Code": "GY"
        },
        {
            "Country": "Haiti",
            "Code": "HT"
        },
        {
            "Country": "Heard and McDonald Islands",
            "Code": "HM"
        },
        {
            "Country": "Honduras",
            "Code": "HN"
        },
        {
            "Country": "Hong Kong",
            "Code": "HK"
        },
        {
            "Country": "Hungary",
            "Code": "HU"
        },
        {
            "Country": "Iceland",
            "Code": "IS"
        },
        {
            "Country": "India",
            "Code": "IN"
        },
        {
            "Country": "Indonesia",
            "Code": "ID"
        },
        {
            "Country": "Iran (Islamic Republic of)",
            "Code": "IR"
        },
        {
            "Country": "Iraq",
            "Code": "IQ"
        },
        {
            "Country": "Ireland",
            "Code": "IE"
        },
        {
            "Country": "Isle of Man",
            "Code": "IM"
        },
        {
            "Country": "Israel",
            "Code": "IL"
        },
        {
            "Country": "Italy",
            "Code": "IT"
        },
        {
            "Country": "Jamaica",
            "Code": "JM"
        },
        {
            "Country": "Japan",
            "Code": "JP"
        },
        {
            "Country": "Jersey",
            "Code": "JE"
        },
        {
            "Country": "Jordan",
            "Code": "JO"
        },
        {
            "Country": "Kazakhstan",
            "Code": "KZ"
        },
        {
            "Country": "Kenya",
            "Code": "KE"
        },
        {
            "Country": "Kiribati",
            "Code": "KI"
        },
        {
            "Country": "Kora, Democratic People's Republic",
            "Code": "KP"
        },
        {
            "Country": "Korea, Republic of",
            "Code": "KR"
        },
        {
            "Country": "Kuwait",
            "Code": "KW"
        },
        {
            "Country": "Kyrgyzstan",
            "Code": "KG"
        },
        {
            "Country": "Lao, People's Democratic Republic",
            "Code": "LA"
        },
        {
            "Country": "Latvia",
            "Code": "LV"
        },
        {
            "Country": "Lebanon",
            "Code": "LB"
        },
        {
            "Country": "Lesotho",
            "Code": "LS"
        },
        {
            "Country": "Liberia",
            "Code": "LR"
        },
        {
            "Country": "Libyan Arab Jamahiriya",
            "Code": "LY"
        },
        {
            "Country": "Liechtenstein",
            "Code": "LI"
        },
        {
            "Country": "Lithuania",
            "Code": "LT"
        },
        {
            "Country": "Luxembourg",
            "Code": "LU"
        },
        {
            "Country": "Macau",
            "Code": "MO"
        },
        {
            "Country": "Macedonia",
            "Code": "MK"
        },
        {
            "Country": "Mdagascar",
            "Code": "MG"
        },
        {
            "Country": "Malawi",
            "Code": "MW"
        },
        {
            "Country": "Malaysia",
            "Code": "MY"
        },
        {
            "Country": "Maldives",
            "Code": "MV"
        },
        {
            "Country": "Mali",
            "Code": "ML"
        },
        {
            "Country": "Malta",
            "Code": "MT"
        },
        {
            "Country": "Marshall Islands",
            "Code": "MH"
        },
        {
            "Country": "Martinique",
            "Code": "MQ"
        },
        {
            "Country": "Mauritania",
            "Code": "MR"
        },
        {
            "Country": "Mauritius",
            "Code": "MU"
        },
        {
            "Country": "Mayotte",
            "Code": "YT"
        },
        {
            "Country": "Mexico",
            "Code": "MX"
        },
        {
            "Country": "Micronesia, Federated States of",
            "Code": "FM"
        },
        {
            "Country": "Moldova, Republic of",
            "Code": "MD"
        },
        {
            "Country": "Monaco",
            "Code": "MC"
        },
        {
            "Country": "Mongollia",
            "Code": "MN"
        },
        {
            "Country": "Montenegro",
            "Code": "ME"
        },
        {
            "Country": "Montserrat",
            "Code": "MS"
        },
        {
            "Country": "Morocco",
            "Code": "MA"
        },
        {
            "Country": "Mozambique",
            "Code": "MZ"
        },
        {
            "Country": "Myanmar",
            "Code": "MM"
        },
        {
            "Country": "Namibia",
            "Code": "NA"
        },
        {
            "Country": "Nauru",
            "Code": "NR"
        },
        {
            "Country": "Nepal",
            "Code": "NP"
        },
        {
            "Country": "New Caledonia",
            "Code": "NC"
        },
        {
            "Country": "New Zealand",
            "Code": "NZ"
        },
        {
            "Country": "Nicaragua",
            "Code": "NI"
        },
        {
            "Country": "Niger",
            "Code": "NE"
        },
        {
            "Country": "Nigeria",
            "Code": "NG"
        },
        {
            "Country": "Niue",
            "Code": "NU"
        },
        {
            "Country": "Norfolk Island",
            "Code": "NF"
        },
        {
            "Country": "Northern Mariana Islands",
            "Code": "MP"
        },
        {
            "Country": "Norway",
            "Code": "NO"
        },
        {
            "Country": "Oman",
            "Code": "OM"
        },
        {
            "Country": "Pakistan",
            "Code": "PK"
        },
        {
            "Country": "Palau",
            "Code": "PW"
        },
        {
            "Country": "Palestinian Territory, Occupied",
            "Code": "PS"
        },
        {
            "Country": "Panama",
            "Code": "PA"
        },
        {
            "Country": "Papua New Guinea",
            "Code": "PG"
        },
        {
            "Country": "Paraguay",
            "Code": "PY"
        },
        {
            "Country": "Peru",
            "Code": "PE"
        },
        {
            "Country": "Philippines PH",
            "Code": "PH"
        },
        {
            "Country": "Pitcairn",
            "Code": "PN"
        },
        {
            "Country": "Poland",
            "Code": "PL"
        },
        {
            "Country": "Portugal",
            "Code": "PT"
        },
        {
            "Country": "Puerto RIco",
            "Code": "PR"
        },
        {
            "Country": "Qatar",
            "Code": "QA"
        },
        {
            "Country": "Reunion",
            "Code": "RE"
        },
        {
            "Country": "Romania",
            "Code": "RO"
        },
        {
            "Country": "Russian Federation",
            "Code": "RU"
        },
        {
            "Country": "Rwanda",
            "Code": "RW"
        },
        {
            "Country": "Saint Barthélemy",
            "Code": "BL"
        },
        {
            "Country": "Saint Helena",
            "Code": "SH"
        },
        {
            "Country": "Saint Kitts and Nevis",
            "Code": "KN"
        },
        {
            "Country": "Saint Lucia",
            "Code": "LC"
        },
        {
            "Country": "Saint Martin",
            "Code": "MF"
        },
        {
            "Country": "Saint Vincent and the Grenadines",
            "Code": "VC"
        },
        {
            "Country": "Samoa",
            "Code": "WS"
        },
        {
            "Country": "San Marino",
            "Code": "SM"
        },
        {
            "Country": "Sao Tome and Principe",
            "Code": "ST"
        },
        {
            "Country": "Saudi Arabia",
            "Code": "SA"
        },
        {
            "Country": "Senegal",
            "Code": "SN"
        },
        {
            "Country": "Serbia",
            "Code": "RS"
        },
        {
            "Country": "Seychelles",
            "Code": "SC"
        },
        {
            "Country": "Sierra Leone",
            "Code": "SL"
        },
        {
            "Country": "Sint Maarten",
            "Code": "SX"
        },
        {
            "Country": "Slovakia (Slovak Republic)",
            "Code": "SK"
        },
        {
            "Country": "Slovenia",
            "Code": "SI"
        },
        {
            "Country": "Solomon Islands",
            "Code": "SB"
        },
        {
            "Country": "Somalia",
            "Code": "SO"
        },
        {
            "Country": "South Africa",
            "Code": "ZA"
        },
        {
            "Country": "South Georgia and the South Sandwich Islands",
            "Code": "GS"
        },
        {
            "Country": "South Sudan",
            "Code": "SS"
        },
        {
            "Country": "Spain",
            "Code": "ES"
        },
        {
            "Country": "Sri Lanka",
            "Code": "LK"
        },
        {
            "Country": "St. Pierre and Miquelon",
            "Code": "PM"
        },
        {
            "Country": "Sudan",
            "Code": "SD"
        },
        {
            "Country": "Suriname",
            "Code": "SR"
        },
        {
            "Country": "Svalbard and Jan Mayen Islands",
            "Code": "SJ"
        },
        {
            "Country": "Swaziland",
            "Code": "SZ"
        },
        {
            "Country": "Sweden",
            "Code": "SE"
        },
        {
            "Country": "Switzerland",
            "Code": "CH"
        },
        {
            "Country": "Syrian Arab Republic",
            "Code": "SY"
        },
        {
            "Country": "Taiwan",
            "Code": "TW"
        },
        {
            "Country": "Tajikistan",
            "Code": "TJ"
        },
        {
            "Country": "Tanzania, United Republic of",
            "Code": "TZ"
        },
        {
            "Country": "Thailand",
            "Code": "TH"
        },
        {
            "Country": "The Netherlands",
            "Code": "NL"
        },
        {
            "Country": "Timor-Leste",
            "Code": "TL"
        },
        {
            "Country": "Togo",
            "Code": "TG"
        },
        {
            "Country": "Tokelau",
            "Code": "TK"
        },
        {
            "Country": "Tonga",
            "Code": "TO"
        },
        {
            "Country": "Trinidad and Tobago",
            "Code": "TT"
        },
        {
            "Country": "Tunisia",
            "Code": "TN"
        },
        {
            "Country": "Turkey",
            "Code": "TR"
        },
        {
            "Country": "Turkmenistan",
            "Code": "TM"
        },
        {
            "Country": "Turks and Caicos Islands",
            "Code": "TC"
        },
        {
            "Country": "Tuvalu",
            "Code": "TV"
        },
        {
            "Country": "Uganda",
            "Code": "UG"
        },
        {
            "Country": "Ukraine",
            "Code": "UA"
        },
        {
            "Country": "United Arab Emirates",
            "Code": "AE"
        },
        {
            "Country": "United Kingdom",
            "Code": "GB"
        },
        {
            "Country": "United States",
            "Code": "US"
        },
        {
            "Country": "United States minor Outlying Islands",
            "Code": "UM"
        },
        {
            "Country": "Uruguay",
            "Code": "UY"
        },
        {
            "Country": "Uzbekistan",
            "Code": "UZ"
        },
        {
            "Country": "Vanuatu",
            "Code": "VU"
        },
        {
            "Country": "Vatican City State (Holy See)",
            "Code": "VA"
        },
        {
            "Country": "Venezuela",
            "Code": "VE"
        },
        {
            "Country": "Vietnam",
            "Code": "VN"
        },
        {
            "Country": "Virgin Islands (British)",
            "Code": "VG"
        },
        {
            "Country": "Virgin Islands (U.S.)",
            "Code": "VI"
        },
        {
            "Country": "Wallis and Futuna Islands",
            "Code": "WF"
        },
        {
            "Country": "Western Sahara",
            "Code": "EH"
        },
        {
            "Country": "Yemen",
            "Code": "YE"
        },
        {
            "Country": "Zambia",
            "Code": "ZM"
        },
        {
            "Country": "Zimbabwe",
            "Code": "ZW"
        }
    ]
}

interface approvedISOType {
    Countries: {Country: string, Code: string}[],
    States: {State: string, Code: string}[],
    Currency: {Currency: string, Code: string}[],
    Provinces: {Province: string, Code: string}[],
}